const { SessionEvent } = require('./session-event');

class ProvisionEvent extends SessionEvent {
  /**
   * @constructor
   * @param {solace.SessionEventCode} sessionEventCode The event code
   * @param {String} infoStr Information string
   * @param {Number} [responseCode] Any associated broker response code
   * @param {solace.ErrorSubcode} [errorSubcode] Any associated error subcode
   * @param {Object|String|null|undefined} [correlationKey] Any associated correlation key
   * @param {String} [reason] Any additional information
   * @param {QueueDescriptor} queueDescriptor Endpoint name and type as returned by the broker
   * @param {QueueProperties} queueProperties Endpoint proerties as returned by the broker
   * @private
   */
  constructor(
      sessionEventCode,
      infoStr,
      responseCode = undefined,
      errorSubcode = 0,
      correlationKey = undefined,
      reason = undefined,
      queueDescriptor = null,
      queueProperties = null) {
  super([], sessionEventCode, infoStr, responseCode, errorSubcode, correlationKey, reason );
  this._queueDescriptor = queueDescriptor;
  this._queueProperties = queueProperties;
  }


  /**
   * @type {QueueDescriptor}
   * @description The endpoint name and type as returned by the broker
   * in the provisioin/deprovision response, if any.
   * Durability is not set.
   * Mostly relevant when the endpoint name was not provided in the provision call.
   * @default null
   */
  get queueDescriptor() {
    return this._queueDescriptor;
  }

  /**
   * @internal
   */
  set queueDescriptor(value) {
    this._queueDescriptor = value;
  }

  /**
   * @type {QueueProperties}
   * @description The endpoint properties as returned by the broker
   * in the provisioin/deprovision response, if any.
   * Mostly relevant in case of an ENDPOINT_PROPERTY_MISMATCH provision error.
   * @default null
   */
  get queueProperties() {
    return this._queueProperties;
  }

  /**
   * @internal
   */
  set queueProperties(value) {
    this._queueProperties = value;
  }
  
  [util_inspect_custom]() {
    const result = super[util_inspect_custom]();
    result.queueDescriptor = this._queueDescriptor;
    result.queueProperties = this._queueProperties;
    return result;
  }

}

module.exports.ProvisionEvent = ProvisionEvent;
